import { render, staticRenderFns } from "./ReservedEvents.vue?vue&type=template&id=2b7bc899"
import script from "./ReservedEvents.vue?vue&type=script&lang=js"
export * from "./ReservedEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports